import React from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "store/store-hooks";
import { useReadUserSubscriptionQuery } from "api/endpoints/subscription";
import { ROUTE_PATH } from "router/router-constant/router.constant";

export const RoleBasedRedirect = () => {
  const { role: userRole } = useAppSelector(
    ({ authReducer: { role } }) => ({ role })
  );

  // Only fetch subscription data for users (not admins)
  const { data: userSubscription } = useReadUserSubscriptionQuery(undefined, {
    skip: userRole === "admin",
  });
  const hasSubscription = userSubscription && userSubscription !== null;

  // Determine the appropriate redirect path based on user role and subscription status
  const getRedirectPath = (): string => {
    switch (userRole) {
      case "admin":
        return ROUTE_PATH.users.list.path;
      case "user":
        // Always redirect to my-subscription page for users
        // The subscription page will handle showing purchase option if needed
        return ROUTE_PATH.subscriptions.mySubscription.path;
      default:
        return ROUTE_PATH.auth.login.path;
    }
  };

  return <Navigate to={getRedirectPath()} replace />;
};
